import { z } from 'zod';
import { ID } from '../../utils/codecUtils';
import { PaginationQuery } from '../../utils/listQuery';
import { listResponse } from '../../utils/listResponse';
import { RelationType } from '../models/relations';
import { relationSchema } from '../models/relations.schema';
import { relationListQuerySchema } from './list.schema';

export type RelationListQuery = Partial<{
  parent: ID[];
  annotation: ID[];
  type: RelationType;
  name: string;
}> &
  PaginationQuery;

export const list = (query: RelationListQuery = {}) => {
  return {
    endpoint: `/relations`,
    method: 'GET',
    responseSchema: listResponse(relationSchema),
    query: { ...query, includeTotal: true },
    querySchema: relationListQuerySchema.and(
      z.object({ includeTotal: z.boolean().optional() })
    ),
  } as const;
};
